import { SVGProps } from "react";

export default function ClipboardIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 15, width = 15, stroke = "#444D5A", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.97156 3.58264H8.35998C9.5542 3.58264 9.5542 2.98553 9.5542 2.38843C9.5542 1.19421 8.95709 1.19421 8.35998 1.19421H5.97156C5.37445 1.19421 4.77734 1.19421 4.77734 2.38843C4.77734 3.58264 5.37445 3.58264 5.97156 3.58264Z"
        stroke={stroke}
        strokeWidth="1.53542"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.5534 2.40036C11.5418 2.50784 12.5389 3.24228 12.5389 5.97106V9.5537C12.5389 11.9421 11.9418 13.1363 8.95629 13.1363H5.37366C2.38812 13.1363 1.79102 11.9421 1.79102 9.5537V5.97106C1.79102 3.24825 2.78818 2.50784 4.77655 2.40036"
        stroke={stroke}
        strokeWidth="1.53542"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}